<template>
	<div class="baby-bar">
		<template v-if="level == 5">
			<div class="bg-red-500 active"></div>
			<div class="bg-red-500"></div>
			<div class="bg-red-500"></div>
			<div class="bg-red-500"></div>
			<div class="bg-red-500 mb-0"></div>
		</template>

		<template v-if="level == 4">
			<div class="bg-gray-400"></div>
			<div class="bg-red-500 active"></div>
			<div class="bg-red-500"></div>
			<div class="bg-red-500"></div>
			<div class="bg-red-500 mb-0"></div>
		</template>

		<template v-if="level == 3">
			<div class="bg-gray-400"></div>
			<div class="bg-gray-400"></div>
			<div class="bg-red-500 active"></div>
			<div class="bg-red-500"></div>
			<div class="bg-red-500 mb-0"></div>
		</template>

		<template v-if="level == 2">
			<div class="bg-gray-400"></div>
			<div class="bg-gray-400"></div>
			<div class="bg-gray-400"></div>
			<div class="bg-red-500 active"></div>
			<div class="bg-red-500 mb-0"></div>
		</template>		

		<template v-if="level == 1">
			<div class="bg-gray-400"></div>
			<div class="bg-gray-400"></div>
			<div class="bg-gray-400"></div>
			<div class="bg-gray-400"></div>
			<div class="bg-red-500 mb-0 active"></div>
		</template>		

		<template v-if="level == 0">
			<div class="bg-gray-400"></div>
			<div class="bg-gray-400"></div>
			<div class="bg-gray-400"></div>
			<div class="bg-gray-400"></div>
			<div class="bg-gray-400"></div>
		</template>			
	</div>

</template>

<script>
	export default {
		props: ['level']
	}
</script>

<style scoped>
	.baby-bar > div { 
		width:7px;
		height:1px;
		margin:0 auto 2px;
	}
	.baby-bar > div.active {
		width: 11px;
	}
</style>